import LoginPage, { loginAction, loginLoader } from "./LoginPage";

export const authRouter = {
  path: "/login",
  id: "login",
  element: <LoginPage />,
  action: loginAction,
  loader: loginLoader,
};
